import { useEffect, useState } from "react";

import { formatDate } from "@ui/utils/formatDate/formatDate";

export const useArticleInfoDisplay = (creationDate: string = "", readTime: string = ""): string => {
  const [formattedCreationDate, setFormattedCreationDate] = useState<string>(readTime);

  useEffect(() => {
    if (creationDate) {
      const formattedCreationDate = formatDate(creationDate);
      if (!formattedCreationDate) {
        return;
      }
      const text = `${formattedCreationDate}${readTime ? ` - ${readTime}` : ""}`;
      setFormattedCreationDate(text);
    }
  }, [creationDate, readTime]);

  return formattedCreationDate;
};
